import React, { Component } from 'react'
import { object } from 'prop-types'
import { translate } from 'react-i18next'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import { stores, view } from './stores'
import { scrollToTop } from './utilities/window'
import { Header } from './components/header/Header'
import { OnLocationChange } from './components/router/OnLocationChange'
import { RouteWhenAuthorized } from './components/router/RouteWhenAuthorized'

/**
 * Pages
 */
import { PagesPaths } from './constants/Pages'

import { NotFoundPage } from './pages/NotFoundPage'
import { SignInPage } from './pages/authentification/SignInPage'
import { SignUpPage } from './pages/authentification/SignUpPage'
import { ConnectAs } from './pages/authentification/ConnectAs'
import { ResetPasswordPage } from './pages/authentification/ResetPasswordPage'

import { MyAccountPage } from './pages/compte/MyAccountPage'
import { EditAccountPage } from './pages/compte/EditAccountPage'

import { InquiryCreationPage } from './pages/demande/InquiryCreationPage'
import { InquirySubmitPage } from './pages/demande/InquirySubmitPage'
import { InquiryCreatedPage } from './pages/demande/InquiryCreatedPage'

import { InquiriesListPage } from './pages/demandes/InquiriesListPage'
import { InquiryVisitPage } from './pages/demandes/visits/InquiryVisitPage'
import { InquiryRealisationPage } from './pages/demandes/realisations/InquiryRealisationPage'
import { InquiryMaintenancePage } from './pages/demandes/maintenances/InquiryMaintenancePage'

import { GardenersPage } from './pages/jardiniers/GardenersPage'
import { GardenerPage } from './pages/jardiniers/GardenerPage'
import { LoggedInAs } from './components/ui/LoggedInAs'

import { GardenerDisponibilityPage } from './pages/disponibilite/GardenerDisponibilityPage'
import { AvanceImmediatePage } from './pages/compte/AvanceImmediatePage'
import { PaymentStatusPage } from './pages/paiement/PaymentStatusPage'

class Router extends Component {
  componentDidMount () {
    const { i18n } = this.props
    if (i18n.isInitialized && !stores.countries.initialized) {
      stores.countries.initialize({ i18n })
    }
  }

  render () {
    return (
      <BrowserRouter basename='/app'>
        <div>
          <OnLocationChange onChange={scrollToTop} />
          <OnLocationChange onChange={() => stores.metadata.clear()} />
          <Header />
          <LoggedInAs authentication={stores.authentication.token} doLogout={() => stores.authentication.logout()} />
          <Switch>
            <Redirect exact path={'/'} to={PagesPaths.SIGNIN.path} />
            {/* Authentication */}
            <Route exact path={PagesPaths.SIGNIN.path} component={SignInPage} />
            <Route exact path={PagesPaths.SIGNUP.path} component={SignUpPage} />
            <Route exact path={PagesPaths.RESET_PASSWORD.path} component={ResetPasswordPage} />
            
            {/* MODIFIED GARDENERS ROUTES - IMPORTANT ORDER */}
            {/*  Canonical route with city AND zip code */}
            <Route exact path={`${PagesPaths.GARDENERS.path}/:city/:code`} component={GardenersPage} />
            {/* Redirection route for city only */}
            <Route exact path={`${PagesPaths.GARDENERS.path}/:city`} component={GardenersPage} />
            
            {/* Public pages / Inquiry creation funnel  */}
            <Route exact path={`${PagesPaths.INQUIRY.path}`} component={InquiryCreationPage} />
            <Route exact path={`${PagesPaths.GARDENER.path}/:id`} component={GardenerPage} />
            {/* Admin connection impersonation */}
            <Route exact path={PagesPaths.CONNECT_AS.path} component={ConnectAs} />
            {/* Gardener disponibility management page */}
            <Route exact path={`${PagesPaths.GARDENER_DISPONIBILITY_MGMT.path}/:token/:secret`} component={GardenerDisponibilityPage} />
            {/* Where a payment link lands when it has nothing left to collect — public: the customer
                of an express invoice has no account, and someone who just paid must not be shown a
                sign-up form instead of an answer */}
            <Route exact path={PagesPaths.PAYMENT_STATUS.path} component={PaymentStatusPage} />
            {/* Inquiry creation management */}
            <RouteWhenAuthorized exact path={PagesPaths.INQUIRY_SUBMIT.path} component={InquirySubmitPage} redirect={PagesPaths.SIGNUP.path} />
            <RouteWhenAuthorized exact path={`${PagesPaths.INQUIRY_CREATED.path}/:id`} component={InquiryCreatedPage} />
            {/* Inquiries management */}
            <RouteWhenAuthorized exact path={PagesPaths.INQUIRIES.path} component={InquiriesListPage} />
            <RouteWhenAuthorized exact path={`${PagesPaths.INQUIRY_VISIT_DETAIL.path}/:id`} component={InquiryVisitPage} />
            <RouteWhenAuthorized exact path={`${PagesPaths.INQUIRY_REALISATION_DETAIL.path}/:id`} component={InquiryRealisationPage} />
            <RouteWhenAuthorized exact path={`${PagesPaths.INQUIRY_MAINTENANCE_DETAIL.path}/:id`} component={InquiryMaintenancePage} />
            {/* Account management */}
            <RouteWhenAuthorized exact path={PagesPaths.ACCOUNT.path} component={MyAccountPage} />
            <RouteWhenAuthorized exact path={PagesPaths.ACCOUNT_EDIT.path} component={EditAccountPage} />
            <RouteWhenAuthorized exact path={PagesPaths.AVANCE_IMMEDIATE.path} component={AvanceImmediatePage} />
            {/* 404 fallback */}
            <Route component={NotFoundPage} />
          </Switch>
        </div>
      </BrowserRouter>
    )
  }
}

Router.propTypes = {
  i18n: object
}

export const Routes = translate()(view(Router))


// WEBPACK FOOTER //
// ./src/routes.js